export default __webpack_public_path__ + "static/image1-c7a7c210a38eb100af269decc5a6d45c.png";